import { render } from "./AddressBook.vue?vue&type=template&id=712fa6f5"
import script from "./AddressBook.vue?vue&type=script&lang=ts"
export * from "./AddressBook.vue?vue&type=script&lang=ts"
script.render = render

export default script